import Validate from 'validator';
import error from '../../config/errorMessages';
import plan from './plan';

if (typeof Array.prototype.reIndexOf === 'undefined') {
	// eslint-disable-next-line no-extend-native,func-names
	Array.prototype.reIndexOf = function (rx) {
		for (const i in this) {
			if (this[i].toString().match(rx)) {
				return i;
			}
		}
		return -1;
	};
}

const extractHostname = (url) => {
	let hostname;
	if (url.indexOf('//') > -1) {
		hostname = url.split('/')[2];
	} else {
		hostname = url.split('/')[0];
	}
	hostname = hostname.split(':')[0];
	hostname = hostname.split('?')[0];
	return hostname;
};

const isset = value => typeof value !== 'undefined';

const domainsBlockedForGoogleDisclosure = [
	'www.facebook.com',
	'www.facebook.com.br',
	'm.facebook.com',
	'm.facebook.com.br',
	'pt-br.facebook.com',
	'pt-br.facebook.com',
	'www.facebok.com',
	'faceebok.com',
	'www.ffacebook.com',
	'fb.com',
	'facebuk.com',
	'www.facebooks.com',
	'www.faceboook.com',
	'www.instaggram.com',
	'www.instagam.com',
	'www.instagrram.com',
	'www.instagra.com',
	'www.instagram.com',
	'www.instagram.com',
	'www.instagram.com.br',
	'www.instagran.com',
	'www.instagramm.com',
	'www.iinstagram.com',
	'www.instagramm.com',
	'cockpit.webmotors.com.br',
];

const isALinkAllowedForDisclosure = (link, domainsBlocked) => {
	const hostname = extractHostname(link).toLowerCase();
	return domainsBlocked.reIndexOf(new RegExp(hostname, 'g')) === -1;
};

const openCheckbox = (question) => {
	question.isValid = true;
	if (!question.valueField) {
		return question;
	}

	const { valueField, required } = question;
	const { values, openOption } = valueField;

	const openOptionHasValue = openOption.length > 0;
	const hasSomeValue = values.toString().length > 0;

	if (values.includes('open')) {
		question.messageErrorField = !openOptionHasValue ? error.OPEN_FIELD_NEED_VALUE : '';
		question.isValid = openOptionHasValue;
		return question;
	}

	if (required) {
		question.messageErrorField = !hasSomeValue ? error.REQUIRED_FIELD : '';
		question.isValid = hasSomeValue;
	}

	return question;
};

const openRadioInput = (question) => {
	question.isValid = true;
	if (!question.valueField) {
		return question;
	}

	const { valueField } = question;
	const { values, openOption } = valueField;

	if (values === 'open') {
		question.isValid = openOption !== '';
		question.messageErrorField = !question.isValid
			? error.OPEN_FIELD_NEED_VALUE : '';
	}

	return question;
};

const emailByQuestion = (question) => {
	question.isValid = true;
	if (Array.isArray(question.valueField)) {
		question.valueField.forEach((value) => {
			question.isValid = !Validate.isEmpty(value) ? Validate.isEmail(value) : true;
			question.messageErrorField = !question.isValid ? error.EMAIL_INVALID : '';
		});
		return question;
	}

	question.isValid = Validate.isEmail(question.valueField)
		&& !Validate.isEmpty(question.valueField);
	question.messageErrorField = !question.isValid ? error.EMAIL_INVALID : '';

	return question;
};

const isEmailField = (question) => {
	const meta = question.meta.typeField ? question.meta : { typeField: 'text' };
	return question.typeField === 'email' || meta.typeField === 'email';
};

const isUrl = link => Validate.isURL(link);

const link = (value, required = true) => {
	let message = '';
	let valid = true;

	if (typeof value === 'undefined' && required) {
		message = error.REQUIRED_FIELD;
		valid = false;
		return { message, valid };
	}

	if (value === '' && required) {
		message = error.REQUIRED_FIELD;
		valid = false;
		return { message, valid };
	}

	if (!Validate.isEmpty(value) && !Validate.isURL(value)) {
		message = error.URL_INVALID;
		valid = false;
		return { message, valid };
	}

	return { message, valid };
};

const planQuestion = (question) => {
	let { valueField } = question;
	valueField = plan.validateChannels(valueField);
	valueField = plan.validateLinks(valueField);
	question.isValid = valueField.isValidPlan;
	question.messageErrorField = valueField.message;
	return question;
};

const forDisclosureOnGoogle = (question) => {
	const { required, valueField } = question;
	question.messageErrorField = '';
	question.isValid = true;

	if (required && valueField === '') {
		question.messageErrorField = error.REQUIRED_FIELD;
		question.isValid = false;
		return question;
	}

	if (!isALinkAllowedForDisclosure(valueField, domainsBlockedForGoogleDisclosure)) {
		question.messageErrorField += '* Link não permitido para divulgação. ';
		question.isValid = false;
	}

	if (!isUrl(valueField)) {
		question.messageErrorField = error.URL_INVALID;
		question.isValid = false;
	}

	return question;
};

const validate = {
	isALinkAllowedForDisclosure,
	forDisclosureOnGoogle,
	emailByQuestion,
	isEmailField,
	openCheckbox,
	openRadioInput,
	isUrl,
	link,
	isset,
	planQuestion,
};

export default validate;
